import { render, staticRenderFns } from "./Facilitadores.vue?vue&type=template&id=448a4e05&"
import script from "./Facilitadores.vue?vue&type=script&lang=js&"
export * from "./Facilitadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports